import { useMemo } from 'react';
import { SortOption } from '../AccommodationsConsole.types';
import { useTranslation } from '@shared/core';

export const useSortOptions = () => {
  const { t } = useTranslation('accommodationsConsole');
  const sortTrans = t('sort');

  const sortOptionsMap = useMemo(
    () =>
      new Map([
        [SortOption.COUPLES_PICKS, sortTrans.couplesPicks()],
        [SortOption.PRICE_LOW_TO_HIGH, sortTrans.priceLowToHigh()],
        [SortOption.PRICE_HIGH_TO_LOW, sortTrans.priceHighToLow()],
        [SortOption.MOST_SAVINGS, sortTrans.mostSavings()],
        [SortOption.DISTANCE, sortTrans.distance()]
      ]),
    [sortTrans]
  );

  const sortOptions = useMemo(() => Array.from(sortOptionsMap.entries()).map(([value, label]) => ({ value, label })), [sortOptionsMap]);

  const getSelectedOptionLabel = (selectedValue: SortOption) => {
    return sortOptionsMap.get(selectedValue) || sortTrans.couplesPicks();
  };

  return {
    sortOptions,
    getSelectedOptionLabel,
    sortTrans
  };
};
